import { useAllCourses } from '../../../../hocs/content/useCourses'
import CoursesGrid from '../../../components/content/courses/CoursesGrid'
import Loading from '../../../components/layout/Loading'
import NoResults from '../../../components/layout/NoResults'

const CoursesExplorer = () => {
  const { data: allCourses, isLoading, error } = useAllCourses()

  if(isLoading) { return <Loading size='fill-container' /> }
  if(!allCourses) return <NoResults />

  return (
    <div>
      <CoursesGrid data={allCourses} isLoading={isLoading} error={error} />
    </div>
  )
}

export default CoursesExplorer
